import * as Yup from "yup";

export const UpdateCitySchema = Yup.object().shape({
  name: Yup.string().required("City name must be filled in"),
  country: Yup.string().required("Country name must be filled in"),
  lat: Yup.number()
    .label("Latitude")
    .min(-90)
    .max(90)
    .required("Coordinates are required"),
  lng: Yup.number()
    .label("Longitude")
    .min(-180)
    .max(180)
    .required("Coordinates are required"),
});
